module.exports = __webpack_public_path__ + "img/logo2.ff87922d.png";